import React from 'react';
import styles from './Choice.scss';

interface ChoiceGroupProps {
    children: React.ReactNode | React.ReactNode[];
}

const ChoiceGroup = ({children}: ChoiceGroupProps) => {
    return (
        <div className={styles['choice-group']} role="radiogroup">
            {children}
        </div>
    );
}

export {ChoiceGroup};
